import { propClassName } from '@/styles/Spinner';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils/cn';

export interface SpinnerLoaderProps extends ComponentProps<'div'> {
  colors?: ClassNameProp<'primary'>;
  size?: ClassNameProp;
  variant?: ClassNameProp;
}

export const SpinnerLoaderComponent: Component<SpinnerLoaderProps> = ({
  colors,
  size,
  variant,
  children,
  className,
  ...props
}) => {
  const colorClassName = propClassName('loader_colors', colors, 'primary');
  const sizeClassName = propClassName('loader_size', size);
  const variantClassName = propClassName('loader_variant', variant);

  const componentClassName = cn(colorClassName, sizeClassName, variantClassName, className);

  return (
    <div className={componentClassName} {...props}>
      {children}
    </div>
  );
};
